import React, { useState, useEffect } from "react";
import { Table, Button } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import { languageSelectors } from "../reducers/laguagesReducer";
import { selectTranslationModel } from "../reducers/translationReducer";
import { segmentsSelectors, segmentStateSelector } from "../reducers/segmentsReducer";
import ReturnDialog from "../components/Modals/ReturnDialog";
import { FadeLoader } from "react-spinners";
import { activeStep, setAnimationClass, returnDialogStateSelector, showReturnDialog } from "../reducers/controlReducer";
// import { fileSelectors, fileState } from "../reducers/uploadFileReducer";
import SegmentControl from "./SegmentControl";

const TranslateFile = (props) => {
  const [showDialog, setShowDialog] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  //set

  let sourceLang = props.languages.find((l) => {
    return l.id === props.model.sourceLanguageId;
  });
  let targetLang = props.languages.find((l) => {
    return l.id === props.model.targetLanguageId;
  });

  //STATE
  const nextClickHandler = () => {
    props.setAnimation("animate__fadeOutLeft");
    setTimeout(() => {
      props.onNextClick({ activeStep: 3 });
    }, 500);
    props.setAnimation("animate__fadeInRight");
  };

  const previousClickHandler = () => {
    props.onPreviousClick(true);
  };

  return (
    <>
      <div className="mt-5 card px-2">
        <div className="row">
          <div className="translate-text pt-5 ps-5">
            <p>
              <span>Translate</span> file
            </p>
          </div>
        </div>
        {props.segmentState.isLoading ? (
          <div className="row">
            <div className={`row loading-scrn animate__animated ${props.animation}`}>
              <FadeLoader className="align-self-center" height={20} width={7} radius={10} margin={12} color={"#43B4E9"}></FadeLoader>
              <span className="loading-text">Translating your file...</span>
            </div>
          </div>
        ) : (
          <>
            <div className="translation-header row">
              <div className="col">
                <p className="ps-4">
                  <br></br>
                </p>
                <span className="translate-from ps-4">{sourceLang.nativeName}</span>
              </div>
              <div className="col">
                <p>Edit translations into:</p>
                <span>{targetLang.nativeName}</span>
              </div>
            </div>
            <div className="segment-list  px-4">
              <Table responsive className="segment-table" borderless={true}>
                <tbody>
                  {props.segments?.map((segment) => (
                    <SegmentControl key={segment.SourceId} segment={segment} />
                  ))}
                </tbody>
              </Table>
              <ReturnDialog show={props.showModal} />
            </div>
            <div className="btns row mx-5 pb-4">
              <Button className="translate-btn-footer prev" type="submit" onClick={() => previousClickHandler()}>
                Previous Step
              </Button>
              <Button className="translate-btn-footer" type="submit" onClick={() => nextClickHandler()}>
                Next Step
              </Button>
            </div>
          </>
        )}
      </div>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    onNextClick: (step) => dispatch(activeStep(step)),
    // updateFileToDownload: (segments) =>
    //   dispatch(updateFileToDownload(segments)),
    onPreviousClick: (isOpen) => dispatch(showReturnDialog(isOpen)),
    setAnimation: (animation) => dispatch(setAnimationClass(animation)),
  };
};
const mapStateToProps = (state) => {
  return {
    languages: languageSelectors.selectAll(state),
    model: selectTranslationModel(state),
    segmentState: segmentStateSelector(state),
    segments: segmentsSelectors.selectAll(state),
    showModal: returnDialogStateSelector(state),
    // animation: animationClass(state),
    // rows: fileSelectors.selectAll(state),
    // activeStep: activeStepSelector(state),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TranslateFile);
